import {$, T} from "../../common/drupal/drupal";

class ParagraphCarrousel {

    /**
     * Initialize event listeners
     */
    init () {
        // slide Paragraph carrousel
        let carrouselId = 0;
        let carrousels = [];
        $('.ParagraphCarrousel-slides:not(.swiper-container)').each(function () {
            $(this).wrap('<div class="swiper-container-wrapper"></div>').addClass('swiper-container').find('.ParagraphSlide').addClass('swiper-slide').wrapAll('<div class="swiper-wrapper"/>');
            $(this).after('<div class="swiper-button-prev swiper-button-prev-carrousel-' + carrouselId + '""></div><div class="swiper-button-next swiper-button-next-carrousel-' + carrouselId + '""></div>');
            carrousels[carrouselId] = new Swiper($(this), {
                slidesPerView: 'auto',
                speed: 1000,
                centerInsufficientSlides: true,
                watchOverflow: true,
                navigation: {
                    nextEl: '.swiper-button-next-carrousel-' + carrouselId,
                    prevEl: '.swiper-button-prev-carrousel-' + carrouselId,
                },
            });
            carrouselId++;
        });
    }

    attach(context) {
        this.init(context);
    }
}

export let paragraphCarrousel = new ParagraphCarrousel();
